import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { COMPANY } from '../data/seedData';

export default function ForbiddenPage() {
  return (
    <>
      <SeoHead
        title="403 - Adgang nægtet - RB Glasfiber A/S"
        description="Du har ikke adgang til denne ressource. Gå til forsiden eller kontakt RB Glasfiber A/S."
      />

      <section className="pt-36 pb-20 min-h-[70vh] flex items-center justify-center bg-slate-50">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-amber-500/10 text-amber-600 text-3xl font-mono font-bold border border-amber-500/30">
            403
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 uppercase tracking-tight">
            Adgang nægtet (403)
          </h1>

          <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
            Du har ikke tilladelse til at tilgå denne side eller ressource.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
            <Link
              to="/"
              className="px-6 py-3 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-xs shadow transition-colors"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="px-6 py-3 rounded bg-slate-900 hover:bg-slate-800 text-white font-bold uppercase tracking-wider text-xs shadow transition-colors"
            >
              Kontakt os
            </Link>
          </div>

          <div className="pt-4 text-xs text-slate-500">
            Spørgsmål? Ring på{' '}
            <a href={`tel:${COMPANY.phoneRaw}`} className="font-bold text-slate-900 underline whitespace-nowrap">
              {COMPANY.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
